import { Component, Input, Output, OnInit, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { EChartOption, ECharts } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';
import { NoiseAnalysisBlockService } from './noise-analysis-block.service'
import * as _ from 'lodash'
import { NoiseAnalysisBlock } from './noise-analysis-interface';

type tool = 'calculate' | 'brush' | 'brushEnlarge' | 'brushRestore' | 'spec';

@Component({
  selector: 'bcac-noise-analiysis-block',
  templateUrl: './noise-analiysis-block.component.html',
  styleUrls: ['./noise-analiysis-block.component.scss']
})
export class NoiseAnaliysisBlockComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService,
    private service: NoiseAnalysisBlockService,
    private cdr: ChangeDetectorRef,
  ) { }


  style = this.commonService.setNoiseAnalysisLineByWindows();


  chartTitle = {
    show: true,
    label: "图表标题"
  };
  initOpts = this.chartOptionService.getInitOpts();
  // 布局设置
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = '';

  // eachrt图表元素
  chartBackgroundColor: string = "#fff";
  chartColors: string[] = this.chartOptionService.getChartColors("default");
  chartTitles = this.chartOptionService.getChartTitle();
  chartGrid = this.service.getChartGrid(this.style);
  chartxAxis = this.service.getChartxAxis();
  chartyAxis = this.service.getChartyAxis();
  chartSeries: EChartOption.Series = [];
  chartTooltip = this.service.getDefaultTooltip();
  chartToolbox = this.service.getChartToolbox();
  chartBrush = this.service.getChartBrush();

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    color: this.chartColors,
    title: this.chartTitles,
    tooltip: this.chartTooltip,
    grid: this.chartGrid,
    xAxis: this.chartxAxis,
    yAxis: this.chartyAxis,
    series: this.chartSeries,
    toolbox: this.chartToolbox,
    brush: this.chartBrush
  };

  bcacIsDarkMode: boolean = false



  //todo  关闭标题栏
  @Input()
  set bcacTitleSwitch(titleSwitch: boolean | string) {
    this.chartTitle.show = typeof (titleSwitch) == "string"
      ? JSON.parse(titleSwitch)
      : titleSwitch;
  }

  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }

  isShowLegend: boolean = true
  @Input()
  bcacIsShowLegend(data: boolean) {
    if (data) {
      this.isShowLegend = typeof (data) == "string"
        ? JSON.parse(data)
        : data;
    }
  }

  //todo loading状态
  public _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Input()
  set bcacXaxisName(xAxisname: string) {
    this.chartOption.xAxis[0].name = xAxisname
  }


  @Input()
  set bcacYaxisName(yAxisNames: string) {
    this.chartOption.yAxis[0].name = yAxisNames
  }

  @Input()
  set bcacYnameGap(yNameGap: number) {
    this.service.setYnameGap(this.chartyAxis, yNameGap);
  }

  @Input()
  set bcacColors(colorList: string[]) {
    this.service.chartColorsChange(this.chartColors, colorList);
  }

  //todo x轴刻度标签旋转
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: number) {
    this.chartOption.xAxis[0].axisLabel.rotate = xAxisLabelRotate;
  }
  //todo  y轴刻度标签旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: number) {
    this.chartOption.yAxis[0].axisLabel.rotate = yAxisLabelRotate;
  }

  //todo tooltip显示格式化
  @Input()
  set bcacTooltipFormatter(value: any) {
    this.chartOption.tooltip = this.service.setTooltipFormat(value);
  }


  toolboxList = []
  @Input()
  set bcacToolboxList(data: tool[]) {
    if (data) {
      this.toolboxList = data
    }
  }
  //todo  图数据
  receiveChartSeriesData  //接收的chart数据
  legendDataList;
  @Input()
  set bcacChartData(chartData: NoiseAnalysisBlock) {
    if (chartData) {
      let option = this.service.changeChartData(this.style, this.chartOption, chartData)
      this.receiveChartSeriesData = option.series.allseries
      this.legendDataList = []
      // if (chartData.toolboxLists) {
      // }
      for (const item of chartData.seriesDatas) {
        this.legendDataList.push({
          label: item.categoryName,
          value: item.nameId,
          checked: item.isChecked
        })

      }
      let checkedSeries = option.series.series
      option.series = checkedSeries
      this.chartOption = option
      this.legendDataList = this.remove_duplicate(this.legendDataList)
    }
  }

  //todo 图例改变
  @Output() bcacLegendCheckedChange: EventEmitter<any> = new EventEmitter<any>()  //lenged选中值
  legendChange(e) {
    let checkedLengend = []
    e.map((item) => {
      if (item.checked) {
        checkedLengend.push(item.value)
      }
    })
    let ydata = []
    let rect = []
    if (this.receiveChartSeriesData && this.receiveChartSeriesData.length) {
      for (const item of this.receiveChartSeriesData) {
        if (item.type == 'bar' || item.type == 'custom') {
          rect.push(item)
        }
        if (checkedLengend.includes(item.nameId)) {
          let cpitem = _.cloneDeep(item)
          delete cpitem.nameId
          ydata.push(item)
        }
      }
    }
    let newseries = ydata.concat(rect)

    if (this.optionInstance) {
      let option = this.optionInstance.getOption()
      option.series = newseries
      this.optionInstance.setOption(option, true);
    }
    this.bcacLegendCheckedChange.emit(e)
  }

  //todo 去重
  remove_duplicate(oldlist) {
    let newlist = {};
    return oldlist.reduce((p, c) => {
      newlist[c.value] ? '' : newlist[c.value] = true && p.push(c);
      return p
    }, []);
  }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>(); //获取实例
  optionInstance;
  onOptionInit(ec) {
    this.optionInstance = ec;
    this.bcacGetChartInstance.emit(ec)
    this.brushMonitor(); //todo
  }


  //todo 框选
  brush(e) {
    this.service.brushTrigger(e, this.optionInstance)
    if (e.type == 'brush_clear') {
      this.isClearActive = false
    }
  }
  @Output() bcacBrushSelected: EventEmitter<any> = new EventEmitter<any>() //框选事件
  isClearActive: boolean = false //是否可清除
  brushMonitor() {
    if (this.optionInstance) {
      this.optionInstance.on('brushEnd', (value) => {
        if (value.areas) {
          this.isClearActive = true
          this.bcacBrushSelected.emit(value)
        }
        this.cdr.detectChanges();
      });
    }
  }

  @Output() bcacBrushEnlarge: EventEmitter<any> = new EventEmitter<any>()
  brushEnlarge(e) {
    this.bcacBrushEnlarge.emit(e.type)
  }

  @Output() bcacBrushRestore: EventEmitter<any> = new EventEmitter<any>()
  brushRestore(e) {
    this.bcacBrushRestore.emit(e.type)
  }

  @Output() bcacBrushCalculation: EventEmitter<any> = new EventEmitter<any>()
  calculate(e) {
    this.bcacBrushCalculation.emit(e.type)
  }

  intervalDatas = [];
  @Input()
  set bcacInterValDatas(value: any[]) {
    if (!_.isNil(value)) {
      this.intervalDatas = value;
    }
  }

  //todo 点击事件
  @Output() bcacRectClick: EventEmitter<any> = new EventEmitter<any>()
  chartClick(e) {
    if (e.componentSubType == "custom") {
      let clickDate = {
        eventID: e.data.value[4],
        startTime: e.data.value[1],
        endTime: e.data.value[2],
      }
      this.bcacRectClick.emit(clickDate)
    }
  }

  //todo 添加鼠标进入事件
  @Output() bcacChartMouseOver: EventEmitter<any> = new EventEmitter<any>()
  chartMouseOver(e) {
    if (e.componentSubType == "custom") {
      return  //方块
    } else {
      this.bcacChartMouseOver.emit(e)
    }
  }

  @Output() bcacShowSpec: EventEmitter<any> = new EventEmitter<any>()
  showSpec(e) {
    this.bcacShowSpec.emit(e)

  }

  // X轴刻度间隔
  axisScaleChange(e: number) {
    if (this.optionInstance) {
      let option = this.optionInstance.getOption()
      option.xAxis[0].axisLabel.interval = e
      this.optionInstance.setOption(option, true)
    }
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateOption()
  }

  updateOption() {
    if (this.optionInstance) {
      this.optionInstance.setOption(this.chartOption, true);
    }
  }




}
